import { GAME_TYPES } from '@/features/gameSession/store/constants';

export const GAME_QUERY_PARAM = 'game';
export const LANE_CHOOSER_THEME_QUERY_PARAM = 'theme';

export type SupportedGameType = (typeof GAME_TYPES)[keyof typeof GAME_TYPES];

const GAME_ROUTE_TYPES: Record<string, SupportedGameType> = {
	'/bouncy-sums': GAME_TYPES.BOUNCY_SUMS_GAME,
	'/lane-chooser': GAME_TYPES.LANE_CHOOSER_GAME,
	'/letter-party': GAME_TYPES.LETTER_PARTY_GAME,
	'/measurement-game': GAME_TYPES.MEASUREMENT_GAME,
	'/time-game': GAME_TYPES.TIME_GAME,
	'/tracing-game': GAME_TYPES.TRACING_GAME,
};

const GAME_DATA_TYPES: Record<string, SupportedGameType> = {
	[GAME_TYPES.BOUNCY_SUMS_GAME]: GAME_TYPES.BOUNCY_SUMS_GAME,
	[GAME_TYPES.LANE_CHOOSER_GAME]: GAME_TYPES.LANE_CHOOSER_GAME,
	[GAME_TYPES.LETTER_PARTY_GAME]: GAME_TYPES.LETTER_PARTY_GAME,
	[GAME_TYPES.MEASUREMENT_GAME]: GAME_TYPES.MEASUREMENT_GAME,
	[GAME_TYPES.TIME_GAME]: GAME_TYPES.TIME_GAME,
	[GAME_TYPES.TRACING_GAME]: GAME_TYPES.TRACING_GAME,
};

const GAME_QUERY_TYPES: Record<string, SupportedGameType> = {
	'bouncy-sums': GAME_TYPES.BOUNCY_SUMS_GAME,
	'canoe-game': GAME_TYPES.LANE_CHOOSER_GAME,
	'lane-chooser': GAME_TYPES.LANE_CHOOSER_GAME,
	'letter-party': GAME_TYPES.LETTER_PARTY_GAME,
	'measurement-game': GAME_TYPES.MEASUREMENT_GAME,
	'time-game': GAME_TYPES.TIME_GAME,
	'tracing-game': GAME_TYPES.TRACING_GAME,
};

export const getSupportedGameType = (value?: string | null): SupportedGameType | null => {
	if (!value) {
		return null;
	}

	return GAME_DATA_TYPES[value] ?? null;
};

export const getGameTypeFromSearchParams = (searchParams: URLSearchParams): SupportedGameType | null => {
	const gameType = searchParams.get(GAME_QUERY_PARAM);

	if (!gameType) {
		return null;
	}

	return GAME_QUERY_TYPES[gameType] ?? null;
};

export const getGameTypeFromPathname = (pathname: string): SupportedGameType | null => {
	return GAME_ROUTE_TYPES[pathname] ?? null;
};

export const getRequestedGameType = (pathname: string, searchParams: URLSearchParams): SupportedGameType | null => {
	return getGameTypeFromSearchParams(searchParams) ?? getGameTypeFromPathname(pathname);
};
